import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../api/client';
import { useNotification } from '../components/Notification';
import './AdminPages.css';

function AdminPages() {
  const queryClient = useQueryClient();
  const notification = useNotification();
  const navigate = useNavigate();

  const { data: pages, isLoading } = useQuery({
    queryKey: ['admin-pages'],
    queryFn: async () => {
      const res = await apiClient.get('/admin/pages');
      return res.data;
    },
  });

  const deleteMutation = useMutation({
    mutationFn: async (id) => {
      await apiClient.delete(`/admin/pages/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['admin-pages']);
      notification.success('Puslapis sėkmingai pašalintas');
    },
    onError: (error) => {
      notification.error(error.response?.data?.error || 'Klaida šalinant puslapį');
    },
  });

  const handleDelete = async (id, title) => {
    const confirmed = await notification.showConfirm(
      'Ar tikrai norite pašalinti šį puslapį?',
      'Patvirtinti puslapio pašalinimą'
    );
    if (confirmed) {
      deleteMutation.mutate(id);
    }
  };

  const handleAddPage = () => {
    navigate('/admin/pages/new');
  };

  const handleEditPage = (page) => {
    navigate(`/admin/pages/${page.id}/edit`);
  };

  if (isLoading) {
    return (
      <div className="admin-pages-page container">
        <div className="pages-header">
          <h1>Puslapių valdymas</h1>
        </div>
        <div className="admin-pages-loading">Kraunama...</div>
      </div>
    );
  }

  return (
    <div className="admin-pages-page container">
      <div className="pages-header">
        <h1>Puslapių valdymas</h1>
        <button type="button" className="btn btn-primary" onClick={handleAddPage}>
          + Pridėti puslapį
        </button>
      </div>

      <div className="pages-list">
        {pages && pages.length > 0 ? (
          pages.map((page) => (
            <div key={page.id} className="page-card">
              <div className="page-info">
                <h3>{page.title_lt || '(be pavadinimo)'}</h3>
                <p className="page-slug">/{page.slug}</p>
                <div className="page-meta">
                  <span className={`status-badge ${page.is_active ? 'active' : 'inactive'}`}>
                    {page.is_active ? 'Aktyvus' : 'Neaktyvus'}
                  </span>
                  <span className="sort-order">Eilė: {page.sort_order}</span>
                </div>
              </div>
              <div className="page-actions">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => handleEditPage(page)}
                  aria-label={`Redaguoti puslapį ${page.title_lt}`}
                >
                  Redaguoti
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleDelete(page.id, page.title_lt)}
                  aria-label={`Šalinti puslapį ${page.title_lt}`}
                >
                  Šalinti
                </button>
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <p>Puslapių nėra. Pridėkite pirmąjį puslapį.</p>
            <button type="button" className="btn btn-primary" onClick={handleAddPage}>
              + Pridėti puslapį
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminPages;
